import { AuthSecurity } from '../../models/auth/auth-security';
import { SuitabilityScore } from '../../models/agents/suitability-score';

export class RegisterScore {
  readonly type = 'REGISTER_SCORE';
  constructor(public suitabilityScore: SuitabilityScore) {}
}

export class ApplyAgentInformation {
  readonly type = 'APPLY_AGENT_INFORMATION';
  constructor(public payload: any) {}
}

export type Actions = RegisterScore;
